import { createContext, ReactNode, useContext } from "react";
import useActiveDiscount from "../hooks/useActiveDiscount";
const PricingContext = createContext<ReturnType<
  typeof useActiveDiscount
> | null>(null);
export function PricingProvider({ children }: { children: ReactNode }) {
  const pricing = useActiveDiscount();
  return (
    <PricingContext.Provider value={pricing}>
      {children}
    </PricingContext.Provider>
  );
}
export default function usePricing() {
  const pricing = useContext(PricingContext);
  if (!pricing) throw new Error("PricingProvider is required");
  return pricing;
}
